// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__DmbUm","inputWrap":"CustomTip_inputWrap__1cIbL"};